export class AirTrackerPlugin {
    constructor(pluginOption) {
        this.name = '';
        // initiation flag
        this.isInit = false;
        this.name = pluginOption.name;
        this.option = pluginOption;
    }
    patch(airTracker) {
        var _a, _b;
        if (!this.isInit) {
            this.isInit = true;
            (_b = (_a = this.option) === null || _a === void 0 ? void 0 : _a.setUp) === null || _b === void 0 ? void 0 : _b.call(this.option, airTracker);
        }
    }
    uninstall() {
        var _a, _b;
        (_b = (_a = this.option) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.apply(this);
    }
}
